import { useEffect, useState } from 'react'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'

import { Page } from '../../../theme/components/Page'
import { PageSection } from '../../../theme/components/PageSection'
import { useHoofdleidingValuelists } from '../../../valuelists/hooks/useHoofdleidingValuelists'
import { ContractinstellingenActiviteiten } from '../components/ContractinstellingenActiviteiten'
import { ContractinstellingenBijlagen } from '../components/ContractinstellingenBijlagen'
import { ContractinstellingenFilters } from '../components/ContractinstellingenFilters'
import { ContractinstellingenLabels } from '../components/ContractinstellingenLabels'
import { ContractinstellingenProjectbetrokkenen } from '../components/ContractinstellingenProjectbetrokkenen'
import { initialState } from '../services/fetchTemplates'
import type { ContractinstellingenBijlagenSearchFilters } from '../types/ContractinstellingenBijlagenSearch'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

type Tab = 'Bijlagen' | 'Activiteiten' | 'Projectbetrokkenen' | 'Labels'

export const Contractinstellingen = () => {
  const {
    data: { verantwoordelijken },
  } = useHoofdleidingValuelists()

  const [filters, setFilters] = useState<ContractinstellingenSearchFilters>({
    verantwoordelijke: null,
  })

  const [bijlagenFilters, setBijlagenFilters] =
    useState<ContractinstellingenBijlagenSearchFilters>(
      initialState.query.filters,
    )

  const [tab, setTab] = useState<Tab>('Bijlagen')

  const handleFiltersChange = (
    newFilters: ContractinstellingenSearchFilters,
  ) => {
    setFilters(newFilters)
    setBijlagenFilters(initialState.query.filters)
  }

  const handleChange = (_: React.SyntheticEvent, newValue: Tab) => {
    setTab(newValue)
  }

  useEffect(() => {
    if (verantwoordelijken.length === 1) {
      setFilters((prev) => ({
        ...prev,
        verantwoordelijke: verantwoordelijken[0],
      }))
    }
  }, [verantwoordelijken])

  return (
    <Page
      title={['Contractinstellingen']}
      breadcrumbs={[
        { label: 'Hoofdleiding', href: '/home', tooltip: 'CAPO home' },
        { label: 'Contractinstellingen' },
      ]}
    >
      <PageSection
        id="contractinstellingen"
        heading="Contractinstellingen"
        subheading="Hier vindt u de instellingen per combi."
      />

      <Box sx={{ marginBottom: 4 }}>
        <ContractinstellingenFilters
          filters={filters}
          onChange={handleFiltersChange}
          options={{ verantwoordelijken }}
        />

        <Tabs value={tab} onChange={handleChange}>
          <Tab label="Bijlagen" value={'Bijlagen'} />

          <Tab label="Activiteiten" value={'Activiteiten'} />

          <Tab label="Projectbetrokkenen" value={'Projectbetrokkenen'} />

          <Tab label="Labels" value={'Labels'} />
        </Tabs>

        <Divider />
      </Box>

      {tab === 'Bijlagen' && (
        <ContractinstellingenBijlagen
          filters={filters}
          bijlagenFilters={bijlagenFilters}
          onChangeBijlagenFilters={setBijlagenFilters}
        />
      )}

      {tab === 'Activiteiten' && (
        <ContractinstellingenActiviteiten filters={filters} />
      )}

      {tab === 'Projectbetrokkenen' && (
        <ContractinstellingenProjectbetrokkenen filters={filters} />
      )}

      {tab === 'Labels' && <ContractinstellingenLabels filters={filters} />}
    </Page>
  )
}
